export const tooltipMixin = {
    methods: {
      showTooltip(event, content) {
        this.$refs.tooltip.showTooltip(event, content);
      },
      hideTooltip() {
        this.$refs.tooltip.hideTooltip();
      }
    }
  };
  